import { TabListProps } from '@reach/tabs'

import { Wrapper, Container, Tab, List } from './style'
import { WORKSPACE_IDS } from '~/config/workspaces'
import { useMemo } from 'react'

type Props = TabListProps & {
  showDonations: boolean
  showFundraisers: boolean
  fundraisersTitle: string
  pageId: string
  workspaceId: string
}

export const TabList = ({
  showDonations,
  showFundraisers,
  fundraisersTitle,
  pageId,
  workspaceId,
  ...rest
}: Props) => {

  const isProsperityRaffle = useMemo(() => {
    return workspaceId === WORKSPACE_IDS.PROSPERITY_INITIATIVE && pageId === 'pg_tGbumG0j4'
  }, [workspaceId, pageId])

  return (
    <Wrapper>
      <Container>
        <List {...rest}>
          <Tab>Story</Tab>
          <Tab className="md:hidden">
            {isProsperityRaffle ? 'Donate Now' : 'Donation Tiers'}
          </Tab>
          <Tab disabled={!showDonations}>Donations</Tab>
          <Tab disabled={!showFundraisers}>{fundraisersTitle}</Tab>
        </List>
      </Container>
    </Wrapper>
  )
}
